import * as React from 'react';
import { useEffect, useState } from 'react';
import {
    Create,
    SimpleForm,
    TextInput,
    SelectInput,
    useDataProvider,
    useNotify,
    required,
    useCreate,
    useRedirect,
    useResourceContext,
    TopToolbar
} from 'react-admin';
import SnInput from '../../Components/SnInput';
import BackButton from '../../Components/BackButton';
import { ErrorDetailsDialog } from '../../Components/ErrorDetailsDialog';

const ActionsToolbar = () => (
    <TopToolbar sx={{ justifyContent: 'start' }}>
        <BackButton />
    </TopToolbar>
);

const validateSnList = (value: string) => {
    if (!value) return undefined;

    // 检查是否包含除了中英文逗号以外的其他标点符号
    const invalidPunctuation = /[!@#$%^&*()_+\-=\[\]{};':"\\|<>?/~`！@#￥%……&*（）——+=\[\]{}；'："\\|《》？～·]/;

    if (invalidPunctuation.test(value)) {
        return 'SN列表只能使用中英文逗号分隔，不能包含其他标点符号';
    }

    return undefined;
};



export const outboundProductCreate = () => {
    const redirect = useRedirect();
    const resource = useResourceContext();

    const [create] = useCreate();
    const dataProvider = useDataProvider();
    const notify = useNotify();
    const [customerTypeChoices, setCustomerTypeChoices] = useState([]);
    const [remainingStock, setRemainingStock] = useState(null);
    const [errorDialogOpen, setErrorDialogOpen] = useState(false);
    const [importResult, setImportResult] = useState<{
        successCount: number;
        failCount: number;
        failedRecords: Array<any>;
    } | null>(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const [types, stock] = await Promise.all([
                    dataProvider.getSalesCustomers(),
                    dataProvider.getStockCount()
                ]);
                setCustomerTypeChoices(types);
                setRemainingStock(stock);
            } catch (error) {
                console.error("数据获取失败:", error);
                notify('数据加载失败', { type: 'error' });
            }
        };

        fetchData();
    }, []);

    // 处理表单提交
    const handleSubmit = (data) => {
        // 将逗号分隔的SN字符串转换为数组

        const processedData = {
            ...data,
            snList: data.snList
                .split(/[,，]+/) // 支持中英文逗号、空格分隔
                .map(sn => sn.trim())
                .filter(sn => sn.length > 0) // 移除空项
        };

        return create(
            'outboundProduct',
            { data: processedData },
            {
                // 成功回调
                onSuccess: (data) => {

                    // 保存导入结果
                    setImportResult({
                        successCount: data.successCount || 0,
                        failCount: data.failCount || 0,
                        failedRecords: data.failedRecords || []
                    });

                    if (data.failCount > 0) {
                        setErrorDialogOpen(true);
                    } else {
                        notify(`导入结果:成功${data.successCount}个，失败${data.failCount}`);
                        redirect('list', resource);
                    }
                    //redirect('list', resource);
                },
                // 失败回调
                onError: (error) => {
                    console.error('暂存失败:', error);
                    notify(`暂存失败: ${error.message || '服务器错误'}`, {
                        type: 'error',
                        autoHideDuration: 3000,
                    });
                }
            })
    };

    const handleCloseErrorDialog = () => {
        setErrorDialogOpen(false);
    };

    return (
        <Create actions={<ActionsToolbar />} redirect="list" mutationOptions={{ onError: (error) => notify(`创建失败: ${error.message}`, { type: 'error' }) }}>
            <SimpleForm
                sx={{ width: { lg: '40%', xs: '100%' } }}
                onSubmit={handleSubmit} // 添加自定义提交处理
            >
                <div style={{
                    fontWeight: 'bold',
                    display: 'flex',
                    alignItems: 'center',
                    marginBottom: '1rem',
                    padding: '0.5rem',
                    backgroundColor: '#f5f5f5',
                    borderRadius: '4px'
                }}>
                    剩余库存: {remainingStock ?? '加载中...'}
                </div>

                <SelectInput
                    choices={customerTypeChoices}
                    label="设备商家"
                    source="saleCustomerId"
                    validate={[required()]}
                    fullWidth
                />
                <SnInput
                    source="snList"
                    label="设备SN"
                    validate={[required(), validateSnList]}
                    helperText="多个序列号请用逗号分隔，在英文输入法下扫条码"
                />
                <TextInput
                    label="收货地址"
                    source="shippingAddress"
                    fullWidth
                    multiline
                />

                <TextInput
                    label="物流单号"
                    source="logisticsNo"
                    fullWidth
                />
            </SimpleForm>
            <ErrorDetailsDialog
                open={errorDialogOpen}
                onClose={handleCloseErrorDialog}
                failedRecords={importResult?.failedRecords || []}
                successCount={importResult?.successCount || 0}
                failCount={importResult?.failCount || 0}
            />
        </Create>
    )
};